import { Box, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { Styles } from './LoginLeftContainerStyles';
import Triangle from '../../assets/images/triangel.png';
import './LoginLeftContainer.css';

const LoginLeftContainer = () => {
  const theme = useTheme();
  const styles = Styles(theme);
  const images = [Triangle, Triangle, Triangle, Triangle, Triangle, Triangle];

  useEffect(() => {
    const gridItems = document.querySelectorAll(
      '.grid-item img',
    ) as unknown as HTMLImageElement[];
    gridItems.forEach((item: HTMLElement, index) => {
      item.style.animationDelay = `${index * 0.75}s`;
    });
  }, []);
  return (
    <Box sx={styles.gridContainer}>
      <div className="grid-item">
        <img src={images[0]} />
      </div>
      <div className="grid-item">
        <img src={images[1]} />
      </div>
      <div className="grid-item empty"></div>
      <div className="grid-item">
        <img src={images[2]} />
      </div>
      <div className="grid-item">
        <img src={images[3]} />
      </div>
      <div className="grid-item">
        <img src={images[4]} />
      </div>
      <div className="grid-item empty"></div>
      <div className="grid-item empty"></div>
      <div className="grid-item">
        <img src={images[5]} />
      </div>
    </Box>
  );
};

export default LoginLeftContainer;
